import { ClearRounded } from "@mui/icons-material";
import { Box, Button, Dialog, DialogActions, IconButton, Stack, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { DataGrid } from "@mui/x-data-grid";
import RenderInputField from "components/PimDashboard/CommonComponents/RenderInputField/RenderInputField";
import { addOrEditModelAction, selectOptionsKeyName } from "components/PimDashboard/data";
import { getColDefaultValue } from "components/PimDashboard/data";
import { converAttrToDatagridCol, datagridcolStyle, datatypes, inputTypes, statusOptions } from "data/globalData";
import { useState } from "react";
import { storesTableColumns, storeTableDummyData } from "../data";

const ProjectionAllStoresModal = ({ modal, setModal, selectedObj, columns }) => {
	const defFields = (() => {
		let obj = {};
		columns?.forEach((row) => {
			obj[row?.key] = getColDefaultValue(row);
		});
		return obj;
	})();

	const projectedGrowthColumn = {
		name: "Projected Growth",
		key: "projected_growth",
		input_type: inputTypes.AUTO_GENERATE.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		default_value: "",
	};

	const [allStores, setAllStores] = useState(storeTableDummyData);
	const [storeTableColumns, setStoreTableColumns] = useState([
		...storesTableColumns?.map((row) => converAttrToDatagridCol(row)),
		{ ...converAttrToDatagridCol(projectedGrowthColumn), editable: true },
	]);

	const handleModalclose = () => {
		setModal(false);
	};

	const handleFormSubmit = async (e) => {
		e.preventDefault();
	};
	return (
		<Dialog maxWidth={"md"} fullWidth open={modal} onClose={handleModalclose} component="form" onSubmit={handleFormSubmit}>
			<Box p={2} height="100%">
				<Box display="flex" justifyContent="space-between" alignItems="center">
					<Typography variant="h6">
						{selectedObj?.channel} - {selectedObj?.season} - Store Projection
					</Typography>
					<Box>
						<IconButton onClick={handleModalclose}>
							<ClearRounded />
						</IconButton>
					</Box>
				</Box>
				<Box pt={1} width="100%">
					<DataGrid
						rows={allStores ?? []}
						columns={storeTableColumns ?? []}
						sx={{
							height: "68vh",
							width: "100%",
							border: "none",
							"& .MuiDataGrid-row": {
								// borderBottom: "1px solid lightgray",
								cursor: "pointer",
								border: "none",
							},
							"& .MuiDataGrid-columnHeader": {
								cursor: "pointer",
								background: grey[300],
							},
							"& .MuiDataGrid-columnHeaders": {
								background: grey[300],
								// mb: 2,
								border: "none",
								borderRadius: 1,
								// padding: "10px 0px",
							},
							"& .MuiDataGrid-footer": {
								background: grey[300],
								// mb: 2,
								border: "none",
								borderRadius: 1,
								// padding: "10px 0px",
							},
						}}
						columnHeaderHeight={35}
						rowHeight={40}
						disableAutosize
						// disableRowSelectionOnClick
						pageSizeOptions={[5, 10]}
					/>
				</Box>

				<DialogActions sx={{ pt: 2, marginTop: "auto" }}>
					<Button variant="outlined" sx={{ justifySelf: "center" }} onClick={handleModalclose}>
						Cancel
					</Button>
					<Button variant="contained" sx={{ justifySelf: "center" }} type="submit">
						Save
					</Button>
				</DialogActions>
			</Box>
		</Dialog>
	);
};

export default ProjectionAllStoresModal;
